import type { WebModule } from "../../core/modules";
import { OutboxPage } from "./routes/outbox";

const xNotifications: WebModule = {
  name: "x-notifications",
  routes: [{ path: "/notifications", element: <OutboxPage />, adminOnly: true }],
  nav: [
    {
      title: "Notifications",
      order: 90,
      adminOnly: true,
      items: [{ to: "/notifications", label: "Courriels", icon: "mail", end: true }],
    },
  ],
};

export default xNotifications;
